import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";

const initialState = {
  ipadLandScape: false,
  ipadPotrait: false,
  iphoneLandScape: false,
  iphonePotrait: false,
};

const AppSlicer = createSlice({
  name: "appSlicer",
  initialState,
  reducers: {
    ipadLandscape: (state: boolean | any, payload: any) => {
      state.ipadLandScape = true;
      state.ipadPotrait = false;
      state.iphoneLandScape = false;
      state.iphonePotrait = false;
    },
    ipadPortrait: (state: boolean | any, payload: any) => {
      state.ipadLandScape = false;
      state.ipadPotrait = true;
      state.iphoneLandScape = false;
      state.iphonePotrait = false;
    },
    iphoneLandscape: (state: boolean | any, payload: any) => {
      state.ipadLandScape = false;
      state.ipadPotrait = false;
      state.iphoneLandScape = true;
      state.iphonePotrait = false;
    },
    iphonePortrait: (state: boolean | any, payload: any) => {
      state.ipadLandScape = false;
      state.ipadPotrait = false;
      state.iphoneLandScape = false;
      state.iphonePotrait = true;
    },
  },
});
export const { ipadLandscape, ipadPortrait, iphoneLandscape, iphonePortrait } =
  AppSlicer.actions;

export const selectBreakPoints = (state: RootState) => state.OnioSlicer;

export default AppSlicer.reducer;
